import React from 'react'

import styles from './LocationMap.module.styl'

const LocationMap = () => {
  return (
    <section className={styles.locationMap}>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2555.236419420243!2d6.581601615876036!3d50.1754158150249!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bfbf438f8f9275%3A0xbec49c56efc673ce!2sDorfstra%C3%9Fe+1%2C+54574+Kopp%2C+Germany!5e0!3m2!1sen!2sus!4v1509376536933" width="800" height="600" frameBorder="0"></iframe>
    </section>
  )
}

export default LocationMap



// WEBPACK FOOTER //
// ./src/components/LocationMap/LocationMap.js